import { ApplicationConfig } from '@angular/core';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter, withComponentInputBinding, withInMemoryScrolling } from '@angular/router';
import { providePrimeNG } from 'primeng/config';
import { MessageService } from 'primeng/api';
import { provideTranslateService, TranslateLoader } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import {
  API_URL,
  APP_NAME,
  FraudTheme,
  HUB_URL,
  JwtInterceptor,
  LoggingInterceptor,
  REPORT_URL,
  SHOW_ETHNIKI_LOGO,
  TranslationLoader,
} from 'shared-library';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { routes } from './app.routes';
import { environment } from '../environments/environment';

export const appConfig: ApplicationConfig = {
  providers: [
    provideHttpClient(withInterceptorsFromDi()),
    provideRouter(
      routes,
      withComponentInputBinding(),
      withInMemoryScrolling({ scrollPositionRestoration: 'top' })
    ),
    provideAnimationsAsync(),
    provideTranslateService({
      defaultLanguage: 'en',
      loader: {
        provide: TranslateLoader,
        useFactory: (http: HttpClient) => new TranslationLoader(http),
        deps: [HttpClient],
      },
    }),
    providePrimeNG({
      theme: { preset: FraudTheme, options: { darkModeSelector: "html[data-theme='dark']" } },
    }),
    MessageService,
    { provide: API_URL, useValue: environment.api },
    { provide: HUB_URL, useValue: environment.hub },
    { provide: REPORT_URL, useValue: environment.reportUrl },
    { provide: APP_NAME, useValue: 'investigator-portal' },
    { provide: SHOW_ETHNIKI_LOGO, useValue: environment.showEthnikiLogo },
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: LoggingInterceptor, multi: true },
  ],
};
